import { plainToInstance, Type } from 'class-transformer';
import { compareDesc } from 'date-fns';
import { SampleOrderStatusV2 } from 'types/models/samples/SampleOrderStatusV2';
import { Nullable } from '@cast/leadcast-types';
import { SamplingKit } from './SamplingKit';
import { SamplingProgram } from './SamplingProgram';
import { ORDER_STATUSES } from 'utils/constants';

export interface SampleOrderV2 {
  id: string;
  externalId: string;
  samplingKit: SamplingKit;
  samplingProgram: SamplingProgram;
  statusHistory: SampleOrderStatusV2[];
  quantity: number;
  address: string;
  addressUnit: Nullable<string>;
  city: string;
  state: string;
  zipcode: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export class SampleOrderV2 {
  @Type(() => SampleOrderStatusV2)
  statusHistory: SampleOrderStatusV2[] = [];

  getStatusTimestamp(statusCode: string): Date | null {
    const status = this.statusHistory.find((status) => status.statusCode === statusCode);
    return status ? status.timestamp : null;
  }

  get currentSampleOrderStatus(): SampleOrderStatusV2 | null {
    const byMostRecent = this.statusHistory
      .map((status) => plainToInstance(SampleOrderStatusV2, status))
      .sort((s1, s2) => compareDesc(s1.timestamp, s2.timestamp));
    return byMostRecent.length > 0 ? byMostRecent[0] : null;
  }

  get orderRequestedTimestamp(): Date | null {
    return this.getStatusTimestamp(ORDER_STATUSES.ORDER_REQUESTED);
  }

  get orderPlacedTimestamp(): Date | null {
    return this.getStatusTimestamp(ORDER_STATUSES.ORDER_PLACED);
  }
}
